import { render, staticRenderFns } from "./VehicleTypeCrudData.vue?vue&type=template&id=29d99dfe"
import script from "./VehicleTypeCrudData.vue?vue&type=script&lang=js"
export * from "./VehicleTypeCrudData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports